<template>
  <VacationApplyInBatchDialogMs
    v-if="isCompanyMicrosoft"
    show
    :selectedUsers="[]"
  />
  <VacationApplyInBatchDialog v-else show :selectedUsers="[]" />
</template>
<script>
import VacationApplyInBatchDialog from "@/components/sign/vacation/VacationApplyInBatchDialog.vue";
import VacationApplyInBatchDialogMs from "@/components/sign/vacation/VacationApplyInBatchDialogMs.vue";
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  name: "ApplyVacationMessage",
  components: { VacationApplyInBatchDialogMs, VacationApplyInBatchDialog },
  computed: {
    ...mapGetters(["isCompanyMicrosoft"]),
  },
};
</script>
